import { render, staticRenderFns } from "./PreviousYears.vue?vue&type=template&id=0ebf43d8&scoped=true&"
import script from "./PreviousYears.vue?vue&type=script&lang=js&"
export * from "./PreviousYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf43d8",
  null
  
)

export default component.exports